import React, { Component } from 'react';
import { connect } from 'react-redux';

import Share from '../Share';
import Logo from '../Logo';

import { restart } from '../../actions';

import style from './index.module.scss';
 
class Header extends Component {
  state = {
    ready: false
  }

  handleRestart() {
    const { dispatch } = this.props;
    dispatch(restart());
  }

  componentDidMount() {
    this.setState(() => ({ ready: true }));
  }
  
  render() {
    const { view: { id, color } } = this.props;
    const { ready } = this.state;
    const c = color || 'black';

    return (
      <div className={`${style.container}`} style={{ color: c, borderBottom: `1px solid ${c}` }}>
        <Logo color={c} className={style.logo} show={ready} />
        <div className={`${style['about-button']} ${id !== 'splash' && id !== 'loading' ? style.active : ''}`}>{process.env.REACT_APP_HEADER_TITLE.replace(/<nbps>/g, '\u00A0')}</div>
        {id !== 'splash' && id !== 'loading' ? <div className={style.border} style={{ background: c }} /> : null}
        <div className={`${style.share}`}>
          <Share show={ready} className={`${style['header-share']}`} useUnderline={false} delay={0.3} color={c} type={'share'} />
        </div>
      </div>
    );
  }
 }

 const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  themes: state.themes,
  base: state.base,
  layout: state.layout
});

export default connect(mapStateToProps)(Header);
